module.exports = __webpack_public_path__ + "components/weather-icon/static/dayrainshowers@3-2d6fc39e2bf15c32e6ece1376a52b030.png";